import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Input,
  Modal, ModalBody, ModalCloseButton,
  ModalContent, ModalFooter, ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure
} from "@chakra-ui/react";
import {AxiosResponse} from "axios";
import {Field, Form, Formik} from "formik";
import React, {useState} from "react";
import {useMutation} from "react-query";
import {useNavigate} from "react-router-dom";

import {
  getExistingId, postResendEmail
} from "../shared/Api";
import {disableBlurProtection} from "../shared/hooks/BlurProtection";
import {customButtonProps, Paths} from "../shared/model/Constants";
import {ResponseDto} from "../shared/model/Dto";
import {enableKeyCommands, isInAvataiSite} from "../shared/Utils";

const ResendEmailAvatai = () => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [idConfirmed, setIdConfirmed] = useState(false);
  const [id, setId] = useState('');
  const [email, setEmail] = useState('');
  const [emailConfirm, setEmailConfirm] = useState('');
  const invalidEmail =  !email.trim() || email !== emailConfirm;
  const [error, setError] = useState('');

  function refreshClick() {
    setId("");
    setIdConfirmed(false);
  }

  disableBlurProtection();
  enableKeyCommands();

  if ( !isInAvataiSite())
    navigate(Paths.HOME, { replace: true });

  const searchExistingId = useMutation<AxiosResponse<ResponseDto>, Error, string>(
    (id: string) => {
      setId(id);
      return getExistingId(id);
    },
    {
      onSuccess: (TData) => {
        if (TData.data.success) {
          setIdConfirmed(true);
          setError("");
        }
        else
          setError(TData.data.message);
      },
    }
  );
  const reSendEmail = useMutation<AxiosResponse<boolean>, Error>(
    () => {
      return postResendEmail(id, email);
    },
    {
      onSuccess: (TData) => {
        if (TData.data.valueOf())
          onOpen();
        else
          setError("No se encontró un usuario asociado");
      },
    }
  );

  return (
    <Box maxW="container.lg" minW="100%" textAlign="center"
         paddingTop="1em" paddingBottom="2em">

      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Reenvío exitoso</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Sus datos de ingreso han sido enviados por correo</Text>
          </ModalBody>
          <ModalFooter>
            <Button
              {...customButtonProps(true)}
              type="submit"
              onClick={()=>navigate(Paths.LOGIN)}
            >
              Iniciar sesión
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Heading width="100%">Reenviar datos</Heading>
      <Container maxW="container.md">
        {!idConfirmed && <Formik
          initialValues={
            {
              id: ""
            }
          }
          onSubmit={(value: { id: string }) =>
            searchExistingId.mutate(value.id)
          }
        >
          <Form>
            <Field name="id">
              {({field}: any) => (
                <FormControl paddingY="1em" isRequired>
                  <FormLabel htmlFor="id">Identificación</FormLabel>
                  <Input {...field} id="id"/>
                </FormControl>
              )}
            </Field>
            <HStack justifyContent="center" >
              <Button
                {...customButtonProps(true)}
                onClick={()=>navigate(Paths.AVATAI_INTRO)}
              >
                Volver
              </Button>
              <Button
                {...customButtonProps(true)}
                type="submit"
              >
                Validar
              </Button>
            </HStack>
          </Form>
        </Formik>}


        {idConfirmed && <Formik
          initialValues={
            {
              email: ""
            }
          }
          onSubmit={(value: { email: string }) =>
            reSendEmail.mutate()
          }
        >
          <Form>
            <Text paddingY="1em">Identificación: {id}</Text>
            <HStack paddingBottom="1em">
              <Field name="email">
                {({field}: any) => (
                  <FormControl isRequired isInvalid={invalidEmail}>
                    <FormLabel htmlFor="email">Correo electrónico</FormLabel>
                    <Input {...field} id="email" type='email'
                           onChange={(e) =>
                             setEmail(e.target.value.toUpperCase())}
                           value={email}/>
                  </FormControl>
                )}
              </Field>
              <Field name="emailC">
                {({field}: any) => (
                  <FormControl isRequired isInvalid={invalidEmail}>
                    <FormLabel htmlFor="emailC">Confirmar correo electrónico</FormLabel>
                    <Input {...field} id="emailC" type='email'
                           onChange={(e) =>
                             setEmailConfirm(e.target.value?.toUpperCase())}
                           value={emailConfirm}/>
                  </FormControl>
                )}
              </Field>
            </HStack>

            <HStack justifyContent="center" >
              <Button
                {...customButtonProps(true)}
                onClick={refreshClick}
              >
                Cambiar identificación
              </Button>
              <Button
                {...customButtonProps(true)}
                type="submit"
                disabled={invalidEmail}
                _disabled={{
                  cursor: 'default',
                  opacity: '0.4',
                }}
              >
                Reenviar datos
              </Button>
            </HStack>
          </Form>
        </Formik>}

      </Container>
      <Text marginY="1em">{error}</Text>
    </Box>
  );
};

export default ResendEmailAvatai;
